import { alpha, styled, Tab, Tabs } from "@mui/material";

export const StyledCustomTabs = {
  LabelContainer: styled('div')(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
  })),
  TabsContainer: styled(Tabs)(({ theme }) => ({
    borderRight: "1px solid #e0e0e0",
    height: "100%",
  })),
  TabPanel: styled(Tab)(({ theme }) => ({
    width: "100%",
    ":hover": {
      backgroundColor: alpha(theme.palette.primary.grey, 0.4),
    },
    '&.Mui-selected': { // Use &.Mui-selected to target the selected state
      backgroundColor: alpha(theme.palette.primary.grey, 0.8),
    },
  })),
  ErrorTabPanel: styled(Tab)(({ theme }) => ({
    ":hover": {
      backgroundColor: alpha(theme.palette.quartary.main, 0.25),
    },
    '&.Mui-selected': { // Use &.Mui-selected to target the selected state
      backgroundColor: alpha(theme.palette.quartary.main, 0.3),
    },
    backgroundColor: alpha(theme.palette.quartary.main, 0.2),
  })),
};